import React from "react";
import { ClearFilterButton, SearchButton } from "./Buttons";

const SKIP_ENTER_SELECTORS = ".ant-input-search";
const POPUP_SELECTORS = ".ant-select-dropdown, .ant-picker-dropdown";
const OVERLAY_SELECTORS = ".ant-modal-wrap, .ant-drawer-open, .modal.show";

const anyVisible = (selectors) =>
  Array.from(document.querySelectorAll(selectors)).some(
    (element) => element.getClientRects().length > 0
  );

function TableFilterBox(props) {
  const boxRef = React.useRef(null);
  const onFilterRef = React.useRef(props.onFilter);
  onFilterRef.current = props.onFilter;

  const enterEnabled = !!props.filter && !!props.onFilter;

  const handleKeyDownCapture = (event) => {
    if (!enterEnabled) return;
    if (event.key !== "Enter" || event.nativeEvent?.isComposing) return;

    const target = event.target;
    if (!target || typeof target.closest !== "function") return;
    if (["TEXTAREA", "BUTTON", "A"].includes(target.tagName)) return;
    if (target.isContentEditable) return;
    if (target.closest(SKIP_ENTER_SELECTORS)) return;
    if (anyVisible(POPUP_SELECTORS)) return;

    event.preventDefault();
    event.stopPropagation();
    onFilterRef.current();
  };

  React.useEffect(() => {
    if (!enterEnabled) return undefined;

    const handleDocumentKeyDown = (event) => {
      if (event.key !== "Enter" || event.isComposing) return;
      if (!boxRef.current || boxRef.current.getClientRects().length === 0) return;

      const active = document.activeElement;
      if (active && active !== document.body && active !== document.documentElement) return;
      if (anyVisible(POPUP_SELECTORS) || anyVisible(OVERLAY_SELECTORS)) return;

      event.preventDefault();
      onFilterRef.current();
    };

    document.addEventListener("keydown", handleDocumentKeyDown);
    return () => document.removeEventListener("keydown", handleDocumentKeyDown);
  }, [enterEnabled]);

  return (
    <div
      ref={boxRef}
      className={`bg-white ${props.extraClass}`}
      style={props.style}
      onKeyDownCapture={handleKeyDownCapture}
    >
      <div className={"bg-white d-flex flex-wrap pl-1 pr-1 pb-2"}>
        {props.children}
      </div>
      {props.button1 && props.button1}
      {props.add && (
        <button
          type="button"
          className="btn btn-sm btn-primary float-right mr-3"
          data-toggle="modal"
          data-target={props.modalId || "#tableEdit"}
          onClick={() => props.add("new")}
        >
          {props.addText || "Create new"}
        </button>
      )}
      {props.export && props.export}

      {props.clearFilter && (
        <ClearFilterButton
          className={`mr-${props.mr}`}
          onClick={props.clearFilter}
        />
      )}
      {props.filter && (
        <SearchButton
          className={`mr-${props.mr}`}
          onClick={props.onFilter}
          text={props.filterText}
        />
      )}
      {props.getInvoices && (
        <button
          className="btn btn-sm float-right mr-3 btn-info"
          onClick={props.getInvoices}
        >
          Gauti sąskaitas
        </button>
      )}
      {props.importPayModulePlans && props.importPayModulePlans}
      <hr />
    </div>
  );
}

TableFilterBox.defaultProps = {
  extraClass: "",
  style: {},
  mr: "3",
};

export default TableFilterBox;
